import React from "react";
import { useNavigate } from "react-router-dom";
import style from "./style.module.css";

const Header = () => {

    const navigate = useNavigate();

    return (
        <div className={style.rootDiv}>
            <div className={style.navigation}>
                <p onClick={() => navigate("/minecraft")}>MINECRAFT</p>
            </div>
        </div>
    );
};

export default Header;